/*       */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { bind } from 'app/utils/decorators/decoratorUtils';
import { set } from 'app/utils/lo/lo';
import Filters from 'app/components/organisms/Filters/Filters';
import VirtualListManaged from 'app/components/molecules/VirtualList/VirtualListManaged';
import { formatOptionsForTask } from 'app/utils/formatter/graphql-formatter';
import TasksViewItem from './TasksViewItem';
import { tasksDefaultFilters, tasksDefaultOrder, tasksFilterDefinitions } from './tasksFilterDefinitions';

const FiltersStyled = styled(Filters)`
    padding: 0 8px;
`;


/**
 * View to display assigned task list
 */
class TasksView extends PureComponent {
    /**
     * @const propTypes - describes the properties of the component
     * @const defaultProps - define the defaults values of the properties
     * @const filterDefinitions -definition for columns that we need to display in our grid
     */
    static propTypes = {
        isLoading: PropTypes.bool,
        records: PropTypes.array,
        startIndex: PropTypes.number,
        totalRecords: PropTypes.number,
        userProfile: PropTypes.object,
        details: PropTypes.object,
        detailsLoading: PropTypes.bool,
    };

    static defaultProps = {
        isLoading: false,
        VirtualListProps: {},
        FiltersProps: {},
        defaultView: 'view-list',
        views: ['view-list', 'view-cards'],
    };

    state = { deleted: {}, feFilters: [], isSidebarOpen: false, key: 1 };

    virtualListRef = React.createRef();

    breadcrumb = [{ title: 'Tasks' }];
    searchBar = ['name', 'id'];
    defaultFilters = tasksDefaultFilters;
    defaultOrder = tasksDefaultOrder;

    filterDefinitions = tasksFilterDefinitions;

    @bind
    openSlidebar() {
        this.setState({ isSidebarOpen: true });
    }

    @bind
    closeSlidebar() {
        this.setState({ isSidebarOpen: false });
    }

    @bind
    handleDelete(id) {
        this.setState({ deleted: set(this.state.deleted, id, true) }, this.forceUpdateGrid);
    }

    @bind
    renderComponent({ style, index, data }) {
        const { deleted } = this.state;
        const { noActions } = this.props;
        const id = data && data.id;
        return (
            <div style={style} key={index}>
                <TasksViewItem
                    data={data}
                    noActions={noActions}
                    resetView={this.resetView}
                    isDeleted={id && deleted[id]}
                    handleDelete={this.handleDelete}
                    openSlidebar={this.openSlidebar}
                />
            </div>
        );
    }

    @bind
    resetView() {
        this.virtualListRef.current && this.virtualListRef.current.resetView();
    }

    @bind
    forceUpdateGrid() {
        this.virtualListRef.current && this.virtualListRef.current.forceUpdate();
    }

    @bind
    loadData(options) {
        const formattedOptions = formatOptionsForTask(options, this.props.userProfile);
        return this.props.loadData(formattedOptions);
    }

    @bind
    reloadList() {
        this.setState(prevState => ({ key: prevState.key + 1 }));
    }

    render() {
        const { renderComponent, FiltersProps, records, isLoading, startIndex, VirtualListProps, className, totalRecords, title } = this.props;
        const { key } = this.state;
        return (
            <>
                <FiltersStyled
                    filterDefinitions={this.filterDefinitions}
                    searchBar={this.searchBar}
                    defaultFilters={this.defaultFilters}
                    defaultOrder={this.defaultOrder}
                    className={className}
                    breadcrumb={this.breadcrumb}
                    {...FiltersProps}
                >
                    {(filterBy, orderBy, excludeBy) => (
                        <VirtualListManaged
                            key={key}
                            itemCount={totalRecords}
                            itemSize={80}
                            isLoading={isLoading}
                            startIndex={startIndex || 0}
                            list={records}
                            maxWidth="1024"
                            loadData={this.loadData}
                            filterBy={filterBy}
                            excludeBy={excludeBy}
                            orderBy={orderBy}
                            title={`${totalRecords >= 1000 ? '999+' : totalRecords} ${title || 'Tasks'}`}
                            renderComponent={renderComponent || this.renderComponent}
                            ref={this.virtualListRef}
                            {...VirtualListProps}
                        />
                    )}
                </FiltersStyled>
            </>
        );
    }
}

export default connect((state, ownProps) => ({
    userProfile: state.user.profile,
}))(TasksView);
